import {
  Button,
  FlexBox,
  JoonUIColor,
  Modal,
  ModalHeader,
  SPACING,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import { useTranslation } from "react-i18next"
import { create } from "zustand"

import { useDeleteRewardMutation } from "../../networking/rewards/mutations"
import { ANALYTIC_EVENTS, trackAnalyticEvent } from "../../util/analytics"
import { useRouter } from "../../util/router"

interface DeleteRewardModalStore {
  isOpen: boolean
  onOpen: (rewardId: number) => void
  onClose: () => void

  rewardId: number | null
}

export const useDeleteRewardModalStore = create<DeleteRewardModalStore>(
  (set) => ({
    isOpen: false,
    onOpen: (rewardId) => set({ isOpen: true, rewardId }),
    onClose: () => set({ isOpen: false, rewardId: null }),

    rewardId: null,
  })
)

const DeleteRewardModal = () => {
  const { isOpen, onClose, rewardId } = useDeleteRewardModalStore()
  const router = useRouter()
  const { t } = useTranslation()

  const deleteRewardMutation = useDeleteRewardMutation()

  const onDeleteRewardClick = () => {
    if (!rewardId) return
    deleteRewardMutation.mutate(rewardId)
    trackAnalyticEvent(ANALYTIC_EVENTS.DELETE_CUSTOM_REWARD)
    router.push("/rewards")
    onClose()
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose} animate>
      <ModalHeader title={t("DRM_TITLE")} onClose={onClose} showBorderBottom />
      <FlexBox
        direction="column"
        gap={SPACING.space4}
        style={{
          padding: `${SPACING.space4} ${SPACING.space6}`,
          width: "min(450px, 95vw)",
        }}
      >
        <Typography variant="body">{t("DRM_DESC_1")}</Typography>
        <Typography variant="body">{t("DRM_DESC_2")}</Typography>

        <FlexBox
          justify="flex-end"
          wrap={false}
          align="center"
          gap={SPACING.space2}
        >
          <TextButton onClick={onClose}>
            <Typography
              variant="bodyBold"
              color={JoonUIColor.text.primaryAccent}
            >
              {t("QB_CANCEL")}
            </Typography>
          </TextButton>

          <Button
            text={t("DRM_TITLE")}
            buttonType="redPrimary"
            isLoading={deleteRewardMutation.isLoading}
            onClick={onDeleteRewardClick}
          />
        </FlexBox>
      </FlexBox>
    </Modal>
  )
}

export default DeleteRewardModal
